import { IFieldTypes } from "../../typings/object/field";
import { SchemaTypes, type SchemaBase } from "../../typings/schema";
import type { IField } from "../../typings/object/field";

// THESE BELOW CAN NEVER CHANGE !!!!!
const customFieldRoot = "system-field";
export const trainingEndDateString = `${customFieldRoot}-00001-training-end-date`;
export const trainingStartDateString = `${customFieldRoot}-00002-training-start-date`;
export const equipmentMakeString = `${customFieldRoot}-00003-equipment-make`;
export const equipmentModelString = `${customFieldRoot}-00004-equipment-model`;
export const equipmentSerialNumberString = `${customFieldRoot}-00005-equipment-serial-number`;
export const equipmentUnitNumberString = `${customFieldRoot}-00006-equipment-unit-number`;
export const equipmentImageFieldString = `${customFieldRoot}-00007-equipment-image`;
// THESE ABOVE CAN NEVER CHANGE

const trainingEndDate: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: trainingEndDateString,
  schema: {
    fieldType: IFieldTypes.dateField,
    name: trainingEndDateString,
    description: "The date this training or certification will expire",
    label: "Expiry Date",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};

const trainingStartDate: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: trainingStartDateString,
  schema: {
    fieldType: IFieldTypes.dateField,
    name: trainingStartDateString,
    description: "The date you completed the training or certification",
    label: "Date Obtained",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};

const equipmentMake: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: equipmentMakeString,
  schema: {
    fieldType: IFieldTypes.textField,
    name: equipmentMakeString,
    description: "Make of the equipment",
    label: "Make",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};
const equipmentModel: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: equipmentModelString,
  schema: {
    fieldType: IFieldTypes.textField,
    name: equipmentModelString,
    description: "Model of the equipment",
    label: "Model",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};

const equipmentSerialNumber: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: equipmentSerialNumberString,
  schema: {
    fieldType: IFieldTypes.textField,
    name: equipmentSerialNumberString,
    description: "Serial number of the equipment",
    label: "Serial Number",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};

const equipmentUnitNumber: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: equipmentUnitNumberString,
  schema: {
    fieldType: IFieldTypes.textField,
    name: equipmentUnitNumberString,
    description: "Unit number the equipment",
    label: "Unit #",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};

const equipmentImage: SchemaBase<IField, never> = {
  type: SchemaTypes.field,
  name: equipmentImageFieldString,
  schema: {
    fieldType: IFieldTypes.imageSelect,
    name: equipmentImageFieldString,
    description: "Image of the equipment",
    label: "Image",
    readonly: false,
    required: true,
    span: 2,
  },
  version: 4,
  buildVersion: 4,
  savedVersions: [],
  buildRefs: {},
  externalRefs: {},
  externalRefIds: [],
  system: true,
};

export default {
  [trainingEndDateString]: trainingEndDate,
  [trainingStartDateString]: trainingStartDate,
  [equipmentMakeString]: equipmentMake,
  [equipmentModelString]: equipmentModel,
  [equipmentSerialNumberString]: equipmentSerialNumber,
  [equipmentUnitNumberString]: equipmentUnitNumber,
  [equipmentImageFieldString]: equipmentImage,
};
